export default "__VITE_ASSET__LmY5xWgA__"